<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="'/visits/tables/manager-activities'"
      [chartColumn]="'Name'"
      [onRowClick]="onRowClick"
    >
    </app-api-table>
  }
</app-tab-layout>
